<template>
  <div>
    <template v-if="!isEdit">
      <template v-if="filter == 'decimal'">
        <span v-if="text" :title="text">{{ text | decimalFormat }}</span>
      </template>
      <template v-else-if="filter == 'image'">
        <template v-if="text">
          <div style="line-height: 0" class="text-xs-center">
            <img
              :src="urlify(text)"
              :alt="text"
              :title="text"
              style="word-wrap: break-word; cursor: pointer; max-width: 600px"
              :style="`width:${selectedBot.theme == 'nvbb' ? '250px' : '100%'}`"
              v-if="urlify(text)"
              @click="isShow = true"
            />
            <preview-image @close="isShow = false" v-model="isShow">
              <img :src="urlify(text)" slot="body" :alt="text" v-if="text" style="width: 100%" />
            </preview-image>
          </div>
        </template>
      </template>
      <template v-else>
        <nl2br v-if="text" tag="span" :text="text" :title="text" style="word-wrap: break-word" />
      </template>
      <template v-if="filter != 'image'">
        <div style="display: inline-block">
          <v-btn flat fab small color="primary" class="ma-0" @click="isEdit = true">
            <v-icon>edit</v-icon>
          </v-btn>
          <template v-if="hasCopy">
            <v-tooltip v-model="showCopy" bottom color="success">
              <template v-slot:activator="{}">
                <v-btn
                  v-if="text"
                  flat
                  fab
                  small
                  class="ma-0"
                  color="primary"
                  v-clipboard:copy="text"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onCopyError"
                >
                  <v-icon>file_copy</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Copied') }}</span>
            </v-tooltip>
          </template>
        </div>
        <!-- <a href="javascript:void(0);" class="small" @click="isEdit = true">
          <span class="fa fa-pencil-alt"></span>
        </a>-->
      </template>
    </template>
    <template v-else>
      <template v-if="type == 'textarea'">
        <div class="form-control">
          <template v-if="selectedBot.theme == 'nvbb'">
            <autoresize-textarea
              @keyup.enter="saveChange"
              rows="3"
              v-model="text"
              style="resize: vertical"
            />
          </template>
          <template v-else>
            <textarea
              @keyup.enter="saveChange"
              rows="3"
              v-model="text"
              style="resize: vertical"
            ></textarea>
          </template>
          <div class="text-xs-center">
            <v-btn outline small color="primary" @click="saveChange">
              <span class="fa fa-pencil-alt mr-2"></span> {{ $t('Save') }}
            </v-btn>
          </div>
        </div>
      </template>
      <template v-else-if="type == 'image'">
        <!-- <img :src="text" :alt="text" :title="text"> -->
      </template>
      <template v-else>
        <div class="form-control" style="display: flex">
          <input @keyup.enter="saveChange" type="text" v-model="text" class="form-control" />
          <a
            @click="saveChange"
            href="javascript:void(0);"
            class="btn btn-floating btn-outline-red text-xs-center btn-small"
            style="margin-left: 5px"
          >
            <span class="fa fa-pencil-alt"></span>
          </a>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import PreviewImage from '@/components/elements/PreviewImage'
import Nl2br from 'vue-nl2br'
import { mapGetters } from 'vuex'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
export default {
  props: ['value', 'type', 'filter', 'hasCopy'],
  data: function () {
    return {
      text: this.value,
      isEdit: false,
      isShow: false,
      showCopy: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  components: {
    PreviewImage,
    Nl2br,
    AutoresizeTextarea
  },
  methods: {
    onCopy() {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    onCopyError() {},
    saveChange: function () {
      this.isEdit = false
      this.$emit('input', this.text)
      this.$emit('edited')
    },
    urlify: function (text) {
      if (!text.startsWith('data:image')) {
        var urlRegex = /(https?:\/\/[^\s]+)/g
        if (text.match(urlRegex) && text.match(urlRegex).length > 0) {
          return text.match(urlRegex)[0]
        }
        return null
      } else {
        return text
      }
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.text = this.value
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/Editable.vue